import React from "react";
import { PerformanceAnalysisSummonerCircle } from "./PerformanceAnalysisChampionCircle";

const PerformanceAnalysisTeamPlayers = (props) => {
  const { teamPlayers } = props;

  if (!teamPlayers) {
    return null;
  }

  let summonerStats = [];
  if (teamPlayers.bestWinRate.accountId !== "-1")
    summonerStats.push({
      iconID: teamPlayers.bestWinRate.profileIcon,
      statText: `${(teamPlayers.bestWinRate.winRate * 100).toFixed(0)}%`,
      label: "BEST WINRATE",
      summonerName: teamPlayers.bestWinRate.summonerName,
    });
  if (teamPlayers.mostAssists.accountId !== "-1")
    summonerStats.push({
      iconID: teamPlayers.mostAssists.profileIcon,
      statText: teamPlayers.mostAssists.assists,
      label: "MOST ASSISTS",
      summonerName: teamPlayers.mostAssists.summonerName,
    });
  if (teamPlayers.bestKda.accountId !== "-1")
    summonerStats.push({
      iconID: teamPlayers.bestKda.profileIcon,
      statText: teamPlayers.bestKda.kda.toFixed(1),
      label: "BEST KDA",
      summonerName: teamPlayers.bestKda.summonerName,
    });

  if (summonerStats.length === 0) return null;

  return (
    <div className="team-players">
      <div className="header-text">
        <div className="small-header">GET CARRIED</div>
        <div className="large-header">TEAM PLAYERS</div>
        <div className="basic-text">Your team is always holding you back, these people a little less.</div>
      </div>
      <div className="profile-icon-list">
        {summonerStats.map((summonerStat, index) => {
          return <PerformanceAnalysisSummonerCircle key={index} isLarge={true} data={summonerStat} />;
        })}
      </div>
    </div>
  );
};

export default PerformanceAnalysisTeamPlayers;
